
export default (value) => {
  if (!value) return value

  const onlyNumbers = value.replace(/[^0-9]/g, '')
  if (onlyNumbers.length !== 10) return value

  return `(${onlyNumbers.slice(0, 3)})${onlyNumbers.slice(3, 6)}-${onlyNumbers.slice(6)}`
}
